import { GameApp } from "./ui/app";

function getStorage(): Storage | undefined {
  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
}

new GameApp(getStorage());
